<template>
    <BareLayout class="text-white integrations">
        <section-hero :section-hero="sectionHero" />
        <section-content
            v-if="sectionContent"
            :section-content="sectionContent"
        />
        <section-gallery
            v-if="showPhotoGallery"
            :section-gallery="sectionGallery"
        />
    </BareLayout>
</template>

<script>
import BareLayout from '@web/components/BarePageLayout';
import SectionHero from '@web/pages/sections/Integrations/SectionHero';
import SectionGallery from '@web/pages/sections/Integrations/SectionGallery';
import SectionContent from '@web/pages/sections/Integrations/SectionContent';
import isEmpty from 'lodash/isEmpty';

export default {
  components: {
    SectionContent,
    BareLayout,
    SectionHero,
    SectionGallery,
  },
  props: {
    pageTitle: {
      type: String,
    },
    sectionHero: {
      type: Object,
      required: true,
    },
    sectionContent: {
      type: String,
      required: false,
    },
    sectionGallery: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showPhotoGallery() {
      return !isEmpty(this.sectionGallery.productGallery);
    },
  },
};
</script>

<style scoped>

</style>
